import React, { useEffect, useState } from 'react';
import DashboardSection from '../components/DashboardSection';
import { Grid } from '@mui/material';
import { Avatar, Colors, PrimaryButton, Text } from 'library';
import DefaultProfileImage from 'assets/icons/Profile.svg';
import * as fromApi from './dashboardApi';
import { consoleLogInDev } from 'shared';
import { useHistory } from 'react-router';
import { styles } from './useStyles';
import type { TProviderRecentlyWorked } from './types';
import { Link } from 'react-router-dom';
import useGoToProfile from '../../providers/cards/actions/goToProfile';

export default function ProviderReviewList() {
    const history = useHistory();
    const [providers, setProviders] = useState<TProviderRecentlyWorked[]>([]);

    const { getProfilePath } = useGoToProfile();

    useEffect(() => {
        fromApi
            .providerReviewList()
            .then((res) => {
                setProviders(res);
            })
            .catch((err) => {
                consoleLogInDev(err);
            });
    }, []);

    return (
        <DashboardSection header="Review Your Workers">
            <Grid container direction="column">
                {providers.length ? (
                    providers.map((provider) => (
                        <Grid
                            key={provider.id}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            wrap="nowrap"
                            style={styles.providerRow}
                        >
                            <Grid item gap={2} style={styles.providerInfo}>
                                <Grid item>
                                    {provider.profile_image?.image ? (
                                        <Avatar src={provider.profile_image?.image} style={styles.avatar} />
                                    ) : (
                                        <DefaultProfileImage style={styles.defaultAvatar} />
                                    )}
                                </Grid>
                                <Grid container item>
                                    <Link
                                        to={getProfilePath(provider)}
                                        style={{ color: Colors.darkNavy, textDecoration: 'underline' }}
                                    >
                                        <Text variant="body1" bold>
                                            {provider.user.first_name} {provider.user.last_name}
                                        </Text>
                                    </Link>
                                    <Grid container direction="row">
                                        {provider.appointments.map((appointment, idx) => (
                                            <Text key={appointment.id} variant="body1">
                                                {appointment.days_times}
                                                {idx < provider.appointments.length - 1 && ',\u00A0'}
                                            </Text>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item alignSelf="end">
                                <PrimaryButton onClick={() => history.push(`/providers/review/${provider.user.id}`)}>
                                    Review
                                </PrimaryButton>
                            </Grid>
                        </Grid>
                    ))
                ) : (
                    <Text variant="body1">You&apos;re all caught up on reviews!</Text>
                )}
            </Grid>
        </DashboardSection>
    );
}
